import "./polyfills"
import "./fonts/fonts.css"
import React from "react"
import ReactDOM from "react-dom/client"
import AppComponent from "./AppComponent"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(<AppComponent />)
